import dayjs, { Dayjs } from 'dayjs'

/**
 * Helper function to convert ISO date string to Dayjs object
 * Extracts year and month from ISO date string using UTC to avoid timezone issues
 */
export function parseISOToMonthYear(isoString: string | null): Dayjs | null {
  if (!isoString) return null
  const date = new Date(isoString)
  if (isNaN(date.getTime())) {
    return null
  }
  return dayjs().year(date.getUTCFullYear()).month(date.getUTCMonth())
}

/**
 * Helper function to convert Dayjs (year/month) to ISO date string
 * Creates Date object for first day of month at midnight UTC (start dates)
 * or last day of month at 23:59:59.999 UTC (end dates)
 */
export function monthYearToISO(dayjsDate: Dayjs | null, isEndDate = false): string | null {
  if (!dayjsDate) return null

  const year = dayjsDate.year()
  const month = dayjsDate.month() // 0-indexed (0 = January)

  if (isEndDate) {
    // For end date, use last day of selected month at 23:59:59.999
    // Use Date constructor to get the last day: new Date(year, month + 1, 0) gives last day of current month
    const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate()
    return new Date(Date.UTC(year, month, lastDayOfMonth, 23, 59, 59, 999)).toISOString()
  } else {
    // For start date, use first day of selected month at 00:00:00.000
    return new Date(Date.UTC(year, month, 1, 0, 0, 0, 0)).toISOString()
  }
}

/**
 * Helper function to extract YYYY-MM string from ISO date for comparison
 */
export function extractYearMonthFromISO(isoString: string | null): string | null {
  if (!isoString) return null
  const date = new Date(isoString)
  if (isNaN(date.getTime())) {
    return null
  }
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}
